import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import PhotoAlbumOutlinedIcon from '@mui/icons-material/PhotoAlbumOutlined';
import PhotoOutlinedIcon from '@mui/icons-material/PhotoOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import InsertCommentOutlinedIcon from '@mui/icons-material/InsertCommentOutlined';
import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined'; // Maybe Library
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import TagFacesOutlinedIcon from '@mui/icons-material/TagFacesOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import SentimentVeryDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentVeryDissatisfiedOutlined';
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DateRangeOutlined from '@mui/icons-material/DateRangeOutlined';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import PlayCircleFilledOutlinedIcon from '@mui/icons-material/PlayCircleFilledOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import { DescriptionOutlined } from '@mui/icons-material';
import SpeakerOutlinedIcon from '@mui/icons-material/SpeakerOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
export const IconPlay = PlayCircleFilledOutlinedIcon;
export const IconDateRange = DateRangeOutlined;
export const IconDateRangeFilled = DateRangeIcon;
export const IconClearDateRange = EventBusyIcon;
export const IconSort = FilterAltOutlinedIcon
export const IconSortFilled = FilterAltIcon;
export const IconHome = HomeOutlinedIcon;
export const IconForward = IosShareOutlinedIcon;
export const IconView = VisibilityOutlinedIcon;
export const IconRefresh = CachedOutlinedIcon;
export const IconEdit = CreateOutlinedIcon;
export const IconSelectClear = HighlightOffOutlinedIcon;
export const IconSelect = CheckCircleOutlinedIcon;
export const IconTrash = DeleteOutlineOutlinedIcon;
export const IconTrashClear = DeleteForeverOutlinedIcon;
export const IconFeed = TableRowsOutlinedIcon;
export const IconGrid = GridOnOutlinedIcon;
export const IconLost = AutoAwesomeOutlinedIcon;
export const IconTag = LocalOfferOutlinedIcon;
export const IconLock = LockOutlinedIcon;
export const IconAdd = AddOutlinedIcon;
export const IconRemove = CloseOutlinedIcon;
export const IconPhotoLibrary = LocalLibraryOutlinedIcon;
export const IconPhotoAlbum = PhotoLibraryOutlinedIcon;
export const IconPhoto = PhotoOutlinedIcon;
export const IconSearch = SearchOutlinedIcon;
export const IconPerson = PersonOutlineOutlinedIcon;
export const IconStarOutlined = StarOutlineOutlinedIcon;
export const IconStarFilled = StarOutlinedIcon;
export const IconSettings = SettingsOutlinedIcon;
export const IconLocation = LocationOnOutlinedIcon;
export const IconComment = InsertCommentOutlinedIcon;
export const IconBack = ArrowBackOutlinedIcon;
export const IconPrev = ArrowBackIosOutlinedIcon;
export const IconNext = ArrowForwardIosOutlinedIcon;
export const IconDownload = FileDownloadOutlinedIcon;
export const IconUpload = FileUploadOutlinedIcon;
export const IconUploadCloud = CloudUploadOutlinedIcon;
export const IconCheck = CheckOutlinedIcon;
export const IconFavoriteOutlined = FavoriteBorderOutlinedIcon;
export const IconFavoriteFilled = FavoriteOutlinedIcon;
export const IconSaveOutlined = BookmarkBorderOutlinedIcon;
export const IconSaveFilled = BookmarkOutlinedIcon;
export const IconShare = GroupOutlinedIcon;
export const IconTeam = TagFacesOutlinedIcon;
export const IconClear = RadioButtonUncheckedOutlinedIcon;
export const IconX = ClearOutlinedIcon;
export const IconError = ErrorIcon;
export const IconFile = DescriptionOutlined;
export const IconAudio = SpeakerOutlinedIcon;
export const IconAttachment = AttachFileIcon;